<template>
  <card card-body-classes="table-full-width">
    <template slot="header">
      <h4 class="card-title">{{ $t('inspector_team_members.tableTitle') }}</h4>
    </template>
    <div>
      <div
        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select
          class="select-primary mb-3 pagination-select"
          v-model="pagination.perPage"
          placeholder="Per page">
          <el-option
            class="select-primary"
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"/>
        </el-select>

        <div class="row">
          <div class="col-6">
            <base-input>
              <el-input
                type="search"
                class="mb-3 search-input"
                prefix-icon="el-icon-search"
                :placeholder="$t('generic.searchInTablePlaceholder')"
                v-model="searchQuery"
                aria-controls="datatables"/>
            </base-input>
          </div>
          <div class="col-6"
               v-if="inspectorTeam != null && ($auth.can({inspector_team_member: 'create'}, 'permissions') || $auth.can({inspector_team_member: 'delete'}, 'permissions'))">
            <join-inspector-team-btn :details="inspectorTeam" v-if="$auth.can({ticket_validation: 'create'}, 'permissions') && $auth.user().inspector_team_id != inspectorTeam.id"/>
            <leave-inspector-team-btn :details="inspectorTeam" v-if="$auth.user().inspector_team_id == inspectorTeam.id"/>
          </div>
        </div>
      </div>

      <el-table v-loading="loading" :data="queriedData" :empty-text="$t('generic.noData')">
        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          :prop="column.prop"
          :label="$t(column.label)"
        >
        </el-table-column>
        <el-table-column align="right"
                         v-if="$auth.can({inspector_team: 'update'}, 'permissions')">
          <div slot-scope="props">
            <base-button
              v-if="$auth.can({inspector_team_member: 'delete'}, 'permissions')"
              @click.native="handleDelete(props.$index, props.row)"
              class="remove btn-link"
              type="danger"
              size="sm"
              icon
            >
              <i class="tim-icons icon-simple-remove"></i>
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <div
      slot="footer"
      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <div class="">
        <p class="card-category">
          {{$t('generic.tablePaginationSummary', {from: from+1, to: to, total: total})}}
        </p>
      </div>
      <base-pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      >
      </base-pagination>
    </div>
  </card>
</template>
<script>
  import swal from 'sweetalert2';
  import {BaseAlert, BasePagination} from "src/components";
  import {Option, Select, Table, TableColumn} from "element-ui";
  import Fuse from "fuse.js";
  import JoinInspectorTeamBtn from './JoinInspectorTeamBtn'
  import LeaveInspectorTeamBtn from './LeaveInspectorTeamBtn'
  import {mapActions, mapState} from "vuex";

  export default {
    name: 'inspector-team-members',
    components: {
      BasePagination,
      BaseAlert,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      JoinInspectorTeamBtn,
      LeaveInspectorTeamBtn
    },
    computed: {
      ...mapState({
        inspectorTeam: state => state.inspector_teams.single,
        error: state => state.inspector_team_members.error,
        loading: state => state.inspector_team_members.loading,
      }),
      /***
       * Returns a page from the searched data or the whole data. Search is performed in the watch section below
       */
      queriedData() {
        let result = this.tableData;
        if (this.searchedData.length > 0) {
          result = this.searchedData;
        }
        return result.slice(this.from, this.to);
      },
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
      total() {
        return this.searchedData.length > 0
          ? this.searchedData.length
          : this.tableData.length;
      }
    },
    data() {
      return {
        pagination: {
          perPage: 50,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['username', 'first_name', 'last_name'],
        tableColumns: [
          {
            prop: 'username',
            label: 'system_account.details.username',
          },
          {
            prop: 'first_name',
            label: 'system_account.details.first_name',
          },
          {
            prop: 'last_name',
            label: 'system_account.details.last_name',
          },
          {
            prop: 'role',
            label: 'system_account.details.role',
          },
          {
            prop: 'status',
            label: 'system_account.details.status',
          },
        ],
        tableData: [],
        searchedData: [],
        fuseSearch: null,
        showEdit: false,
        editOperator: {},
      };
    },
    methods: {
      ...mapActions(['LoadInspectorTeamMembers', 'DeleteInspectorTeamMember']),
      handleDelete(index, row) {
        swal({
          title: this.$t('inspector_team_members.delete.text'),
          text: `'${row.username}'`,
          confirmButtonText: this.$t('inspector_team_members.delete.actionBtnLabel'),
          cancelButtonText: this.$t('inspector_team_members.delete.cancelBtnLabel'),
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-secondary',
          type: 'question',
          showCancelButton: true
        }).then(result => {
          if (result.value) {
            let payload = {
              id: this.$route.params.id,
              member_id: row.id,
              username: row.username,
            }
            this.DeleteInspectorTeamMember(payload).then(() => {
              if (this.error == null) {
                if (this.$auth.user().id == payload.member_id) {
                  // Refresh token and user data after inspector member deletion.
                  this.$auth.refresh();
                  this.$auth.fetch();
                }
                this.$notify({
                  type: 'success',
                  message: this.$t('inspector_team_members.delete.deletedNotification', payload),
                  icon: 'tim-icons icon-alert-circle-exc'
                })
              }
              this.LoadInspectorTeamMembers(this.$route.params.id)
            })
          }
        });
      },
    },
    mounted() {
      this.LoadInspectorTeamMembers(this.$route.params.id)
    },
    watch: {
      "$store.state.inspector_team_members.data"(data) {
        this.tableData = data
        // Fuse search initialization.
        this.fuseSearch = new Fuse(this.tableData, {
          keys: this.propsToSearch,
          threshold: 0.3
        });
      },
      /**
       * Searches through the table data by a given query.
       * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
       * @param value of the query
       */
      searchQuery(value) {
        let result = this.tableData;
        if (value !== '') {
          result = this.fuseSearch.search(this.searchQuery);
        }
        this.searchedData = result;
      },
    }
  };
</script>
<style></style>
